<div class="container-fluid client-list-container">
    <div class="row my-3">
        <div class="col">
            <div class="card">
                <div class="card-header">
                    Manage your Customers
                    <!-- <ul class="nav float-right">
            <li class="nav-item">
              <div class="btn-group btn-group-sm" role="group" aria-label="Basic example">
                <button type="button" class="btn btn-link"><i class="fa fa-plus-circle"></i></button>
                <button type="button" class="btn btn-link"><i class="fa fa-file-export"></i></button>
                <button type="button" class="btn btn-link"><i class="fa fa-file-import"></i></button>
              </div>
            </li>
          </ul> -->
                </div>
                <div class="card-body">
                    <app-data-table [columns]="columns" [pageSize]="25" [loadPage]="loadPage" [(filters)]="filters"
                        [filtersComponent]="dataFilters" [tBodyTrAdditionalClass]="tBodyTrAdditionalClass">
                        <app-data-filters #dataFilters>
                            <app-data-filter-group>
                                <app-data-filter-input [label]="'client-list.id.label' | translate"
                                    [(model)]="filters.id" [placeholder]="'client-list.id.placeholder' | translate">
                                </app-data-filter-input>
                                <app-data-filter-input [label]="'Customer name' | translate"
                                    [(model)]="filters.customerName"
                                    [placeholder]="'client-list.firstName.placeholder' | translate">
                                </app-data-filter-input>
                                <app-data-filter-input [label]="'client-list.email.label' | translate"
                                    [(model)]="filters.email"
                                    [placeholder]="'client-list.email.placeholder' | translate"></app-data-filter-input>
                                <app-data-filter-input [label]="'client-list.company.label' | translate"
                                    [(model)]="filters.company"
                                    [placeholder]="'client-list.company.placeholder' | translate">
                                </app-data-filter-input>
                                <app-data-filter-datepicker label="Registration Date"
                                    [(model)]="filters.registrationDate"></app-data-filter-datepicker>
                                <app-data-filter-select label="Status" [(model)]="filters.status"
                                    [options]="clientStatusOptionArray"></app-data-filter-select>
                            </app-data-filter-group>
                        </app-data-filters>
                    </app-data-table>
                    <div class="btn-group dropup navbar p-0">
                        <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false" style="width: 10%; flex: 0">
                            Bulk actions
                        </button>
                        <div class="dropdown-menu">
                            <button class="dropdown-item btn-sm" type="button"
                                (click)="changeStatusSelectedClients(1)"><i class="fa fa-power-off"
                                    style="color: green"></i> Enable selection</button>
                            <button class="dropdown-item btn-sm" type="button"
                                (click)="changeStatusSelectedClients(0)"><i class="fa fa-power-off"
                                    style="color: red"></i> Disable selection</button>
                            <div class="dropdown-divider"></div>
                            <button class="dropdown-item btn-sm" type="button" (click)="softDeleteSelectedClients()"><i
                                    class="fa fa-trash-alt"></i> Delete selected</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<ng-template #selectColumn let-id="id">
    <input type="checkbox" [value]="id" (change)="onClientCheckboxSelected($event)" />
</ng-template>

<ng-template #idColumn let-id="id">
    {{id}}
</ng-template>

<ng-template #customerTitle let-title="title">
    {{title}}
</ng-template>

<ng-template #customerName let-firstName="firstName" let-lastName="lastName">
    {{firstName}} {{lastName}}
</ng-template>

<ng-template #emailColumn let-email="firstEmail">
    <a href="mailto:{{email}}"><i class="fa fa-envelope"></i>{{email}}</a>
</ng-template>

<ng-template #phoneColumn let-phone="firstPhone">
    {{phone}}
</ng-template>

<ng-template #statusColumn let-status="status">
    <span [outerHTML]="status | clientStatusBadge"></span>
</ng-template>

<ng-template #firstLogin let-firstLogin="firstLogin">
    <ng-container *ngIf="firstLogin === 0; else noNewsletterTemplate">
        <i style="color: green;" class="fas fa-check"></i>
    </ng-container>
    <ng-template #noNewsletterTemplate>
        <i style="color: red;" class="fas fa-times"></i>
    </ng-template>
</ng-template>

<!-- <ng-template #newsletterColumn let-newsletter="newsletter">
    <ng-container *ngIf="newsletter === 1; else noNewsletterTemplate">
        <i style="color: green;" class="fas fa-check"></i>
    </ng-container>
    <ng-template #noNewsletterTemplate>
        <i style="color: red;" class="fas fa-times"></i>
    </ng-template>
</ng-template> -->

<ng-template #createdAtColumn let-createdAt="createdAt">
    {{createdAt | date:'dd/MM/yyyy HH:mm'}}
</ng-template>

<ng-template #confirmedAtColumn let-confirmedAt="confirmedAt">
  {{confirmedAt | date:'dd/MM/yyyy HH:mm'}}
</ng-template>

<ng-template #draftsColumn let-drafts="drafts">
  {{drafts}}
</ng-template>

<ng-template #companyColumn let-company="company">
    <ng-container *ngIf="company.id"> <a href="companies/details/{{company.id}}" target="_blank"><i
                class=" fa fa-share"></i>
            {{company.name}}</a>
    </ng-container>
</ng-template>

<ng-template #companyStatusColumn let-company="company">
    <ng-container *ngIf="company.id">
        <ng-container *ngIf="company.status === 1; else otherStatus">
            <span class="badge badge-success"><i class="fa fa-check"></i>{{company.status | companyStatus}}</span>
        </ng-container>
        <ng-template #otherStatus>
            <ng-container *ngIf="company.status === 2; else delete1Template">
                <span class="badge badge-warning"><i
                        class="fa fa-exclamation"></i>{{company.status | companyStatus}}</span>
            </ng-container>
            <ng-template #delete1Template>
                <span class="badge badge-danger"><i
                        class="fa fa-minus-circle"></i>{{company.status | companyStatus}}</span>
            </ng-template>
        </ng-template>
    </ng-container>
</ng-template>

<ng-template #actionsColumn let-id="id">
    <div class="btn-group navbar p-0" style="display: block">
        <a href="clients/edit/{{id}}" class="btn btn-secondary btn-sm"><i class="fa fa-pencil-alt"></i> Edit</a>
        <button type="button" class="btn btn-sm btn-secondary dropdown-toggle dropdown-toggle-split"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="width: 30px">
            <span class="sr-only">Toggle Dropdown</span>
        </button>
        <div class="dropdown-menu dropdown-menu-right">
            <a href="clients/view/{{id}}" class="dropdown-item btn btn-sm"><i class="fa fa-search-plus"></i> View</a>
            <a href="clients/duplicate/{{id}}" class="dropdown-item btn-sm"><i class="fa fa-copy"></i> Duplicate</a>
            <button type="button" class="dropdown-item btn-sm" (click)="accessClientFrontend(id)"><i
              class="fa fa-link"></i>Access as client</button>
            <button type="button" class="dropdown-item btn-sm" (click)="softDeleteClient(id)"><i
                    class="fa fa-trash-alt"></i>Delete</button>
        </div>
    </div>
</ng-template>

<ng-template #notesColumn let-company="company">
  <button type="button" class="btn btn-sm btn-secondary" *ngIf="company.notes" (click)="openToaster(company)"><i class="fa fa-info-circle"></i></button>
  <button type="button" class="btn btn-sm btn-secondary" *ngIf="company.notes" (click)="editNotes(company)"><i class="fa fa-edit"></i></button>
</ng-template>
